import storeMapFactory from './StoreMap';

export default (bottle) => {
  storeMapFactory(bottle);
};



// WEBPACK FOOTER //
// ./src/StoreMap/index.js